import Swiper from 'swiper';
import { Navigation, A11y, Keyboard } from 'swiper/modules';

// Blueprint: LP Slider (Anwendungsbeispiele)
// 1:1 aus Figma (node 410:1163): horizontaler Slider mit ~2,7 sichtbaren Slides
// (Peek), Nav-Pfeile oben links. Swiper 11, Vanilla-Init je .js-lpSlider-Root.

// Einmaliger Stagger-Reveal beim ersten Reinscrollen: Kacheln starten leicht
// abgesenkt/gedimmt (nicht unsichtbar — der Anschnitt-Peek unterm Hero muss
// erkennbar bleiben) und sliden nacheinander hoch. Danach werden alle
// Animations-Klassen entfernt, der Slider ist wieder komplett statisch.
function initReveal(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const slides = Array.from(root.querySelectorAll('.lpSlider__slide'));
    if (!slides.length) return;

    slides.forEach((slide, i) => slide.style.setProperty('--lpSlider-reveal-i', i));
    root.classList.add('is-revealArmed');

    const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        root.classList.add('is-revealed');

        const total = 700 + (slides.length - 1) * 150;
        window.setTimeout(() => {
            root.classList.remove('is-revealArmed', 'is-revealed');
            slides.forEach((slide) => slide.style.removeProperty('--lpSlider-reveal-i'));
        }, total + 100);
    }, { rootMargin: '0px 0px -35% 0px' });

    observer.observe(root);
}

export function initLpSlider() {
    document.querySelectorAll('.js-lpSlider').forEach((root) => {
        const container = root.querySelector('.js-lpSliderSwiper');
        if (!container) return;

        initReveal(root);

        const prevEl = root.querySelector('.js-lpSliderPrev');
        const nextEl = root.querySelector('.js-lpSliderNext');

        new Swiper(container, {
            modules: [Navigation, A11y, Keyboard],
            slidesPerView: 1.1,     // mobile: eine Karte + Peek
            spaceBetween: 12,       // Figma: gap 12px
            grabCursor: true,
            watchOverflow: true,
            keyboard: { enabled: true },
            a11y: { enabled: true },
            navigation: { prevEl, nextEl },
            breakpoints: {
                768:  { slidesPerView: 2.2 },
                1024: { slidesPerView: 2.4 },
                1250: { slidesPerView: 2.7 },   // Figma: 467px-Slides in 1300px + Peek
            },
        });
    });
}
